import axios from "axios";
import TokenService from "../services/token-service";

const apiBaseUrl = import.meta.env.VITE_API_BASE_URI ;//|| "http://localhost:3000"; // Load from `.env`

// Create Axios Instance
const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    "Content-Type": "application/json"
  },
  // timeout: 20000, // Optional: Set timeout
});

// if token available
const token = TokenService.getLocalAccessToken();

//localStorage.getItem("user-token");
if (token) {
  axiosInstance.defaults.headers.common["Authorization"] = token;
  console.log("axiosInstance.defaults.headers.common", axiosInstance.defaults.headers.common);
}
export default axiosInstance;

